/*
  HORANDO - mobile Anpassungen, Stand 16.09.2026 (vierter Durchgang).
  Gehoert zu assets/horando-braun-mobil.css und wird in
  layout/theme.liquid mit defer geladen.

  Aufgaben:

  1. Lange Marken- und Kollektionstexte bekommen ein "weiterlesen".
  2. Die vier Linklisten im Footer werden zu Akkordeons.
  3. Das Markenpraefix in den Trust-Ueberschriften faellt mobil weg.
  4. Der Modellname wandert auf der Produktseite unter das Bild.
  5. Im Footer entsteht eine Leiste mit den Guetesiegeln.
  6. Newsletter: richtiger Platzhalter, richtig angeordnetes
     Einwilligungs-Kaestchen, deutsche Fehlermeldungen.
     Dazu der Platzhalter der Suchzeile im Kopfbereich.
  7. Das Suchoverlay bekommt eine Hoehe, die die Tastatur beruecksichtigt.
  8. Die Produktbilder bekommen eine Lupe und eine Vollbildansicht.

  Bewusste Entscheidungen:

  - Das Skript setzt nur Klassen, haengt Elemente an und schreibt eine
    CSS-Variable; ob und wie sich das auswirkt, entscheidet allein die
    CSS-Datei ueber ihre Medienabfrage. Beim Drehen des Geraets muss
    deshalb nichts rueckgaengig gemacht werden.

  - Ob ein Textblock eingeklappt wird, entscheidet die ZEICHENZAHL,
    nicht die gemessene Hoehe: die Bloecke laufen auf dem Desktop
    mehrspaltig, eine Hoehenmessung faellt dort ganz anders aus.

  - Die Beschriftung kommt vom vorhandenen Schalter im Kopfbereich
    (.collection-header-section__button mit data-read-more /
    data-read-less) - damit stimmt sie in allen zehn Sprachen.

  - Footer und Klaviyo-Formular werden verzoegert aufgebaut. Deshalb
    laeuft der Aufbau mehrfach (DOMContentLoaded, load, nach 1,5 s),
    zusaetzlich ueber einen MutationObserver und - fuer das
    Klaviyo-Formular - ueber eine kurze Nachlaufschleife. Alle Schritte
    sind wiederholbar und tun beim zweiten Mal nichts mehr.
*/
(function () {
  'use strict';

  var MIN_CHARS = 420; // kuerzere Bloecke lohnen den Schalter nicht

  /* Trusted-Shops-Kennung aus sections/trustpilot-trustedshops.liquid;
     hier wiederverwendet, damit es nur EINE Pflegestelle gibt. */
  var TS_WIDGET_ID = 'wdg-cf4ae2a3-e408-4720-9e21-0448eff93837';
  var TP_REVIEW_URL = 'https://de.trustpilot.com/review/horando.de';

  /* Adresse der eigenen Theme-Dateien, abgeleitet aus dem
     <script>-Tag dieser Datei. So steht hier keine CDN-Adresse fest
     verdrahtet - die aendert sich mit jedem Theme. */
  function assetUrl(name) {
    var tag = document.querySelector('script[src*="horando-braun-mobil.js"]');
    if (!tag || !tag.src) return '';
    return tag.src.replace(/horando-braun-mobil\.js.*$/, name);
  }

  function labels() {
    var src = document.querySelector('.collection-header-section__button');
    return {
      more: (src && src.getAttribute('data-read-more')) || 'weiterlesen',
      less: (src && src.getAttribute('data-read-less')) || 'weniger'
    };
  }

  function uid() {
    return 'hb-' + Math.random().toString(36).slice(2, 8);
  }

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  /* ---------- 1. Textbloecke einklappen ---------- */

  function collapseTexts() {
    var text = labels();
    var blocks = document.querySelectorAll(
      '.brand-content-block__content, .collection-bottom-content__content, ' +
      /* Startseite: der ganze SEO-Abschnitt hinter EINEN Schalter. Die
         einzelnen .rte-Bloecke darin zu greifen ergaebe neun
         "weiterlesen" untereinander. */
      'body.template-index #MainContent > [id*="__rich_text"]'
    );

    Array.prototype.forEach.call(blocks, function (el) {
      if (el.getAttribute('data-hb-collapsible') === 'done') return;
      el.setAttribute('data-hb-collapsible', 'done');

      if ((el.textContent || '').trim().length < MIN_CHARS) return;

      el.classList.add('hb-collapsible', 'hb-collapsed');

      /* HORANDO 17.09.2026 - Zeilen statt Pixel: der erste Absatz wird
         auf drei Zeilen gekuerzt, alles danach ausgeblendet (siehe
         Abschnitt 5 der CSS-Datei). Was nach dem Absatz kommt, wird auf
         jeder Ebene bis hinauf zum Block markiert - so greift es auch,
         wenn der Text in einem zusaetzlichen Container steckt. */
      var lead = el.querySelector('p');
      if (lead && (lead.textContent || '').trim().length > 0) {
        lead.classList.add('hb-lead');
        var node = lead;
        while (node && node !== el) {
          var sib = node.nextElementSibling;
          while (sib) {
            sib.classList.add('hb-rest');
            sib = sib.nextElementSibling;
          }
          node = node.parentElement;
        }
        el.classList.add('hb-collapsible--lines');
      }

      /* Auf der Startseite steckt die Ueberschrift MIT im Textcontainer;
         sonst bliebe von der H2 nur eine halbe Zeile stehen. */
      if (el.closest('.template-index')) el.classList.add('hb-collapsible--lead');
      if (!el.id) el.id = uid();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hb-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', el.id);
      btn.textContent = text.more;

      el.parentNode.insertBefore(btn, el.nextSibling);

      btn.addEventListener('click', function () {
        var collapsed = el.classList.toggle('hb-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        btn.textContent = collapsed ? text.more : text.less;
        if (collapsed) {
          var pos = el.getBoundingClientRect().top;
          if (pos < 0) el.scrollIntoView({ block: 'start' });
        }
      });
    });
  }

  /* ---------- 2. Footer-Listen als Akkordeon ---------- */

  function collapseFooter() {
    var blocks = document.querySelectorAll('.footer__block--menu');

    Array.prototype.forEach.call(blocks, function (block) {
      if (block.getAttribute('data-hb-acc') === 'done') return;

      var head = block.querySelector('.footer__title');
      var list = block.querySelector('.footer__menu');
      if (!head || !list) return;

      block.setAttribute('data-hb-acc', 'done');
      block.classList.add('hb-acc');

      if (!list.id) list.id = uid();
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');
      head.setAttribute('aria-controls', list.id);

      function toggle() {
        var open = block.classList.toggle('hb-acc--open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  /* ---------- 3. Markenpraefix in den Trust-Ueberschriften ---------- */
  /*
    "HORANDO - AUSWAHL & EXKLUSIVITAET" dreimal untereinander auf 375px
    ist reine Wiederholung. Das Praefix wird nur aus der ANZEIGE
    genommen; der Text in der Section bleibt unangetastet, Desktop und
    alle zehn Uebersetzungen aendern sich nicht.
  */

  function trimFeatureHeadings() {
    if (!isMobile()) return;

    var heads = document.querySelectorAll(
      '.horando-features-section .feature-content h3'
    );

    Array.prototype.forEach.call(heads, function (h) {
      if (h.getAttribute('data-hb-trimmed') === 'done') return;
      h.setAttribute('data-hb-trimmed', 'done');

      var text = (h.textContent || '').trim();
      var cut = text.replace(/^HORANDO\s*[-–—]\s*/i, '');
      if (cut && cut !== text) h.textContent = cut;
    });
  }

  /* ---------- 4. Produktseite: Modellname unter das Bild ---------- */

  function productTitleUnderPhoto() {
    /* Produkte laufen teils auf abgewandelten Vorlagen, der Body traegt
       dann template-product-b2b-... - deshalb Praefix pruefen. */
    if (!/(^|\s)template-product/.test(document.body.className)) return;
    if (!isMobile()) return;

    var photos = document.querySelector('.product__photos');
    var head = document.querySelector('.heading-mobile');
    if (!photos || !head) return;

    var title = head.querySelector('.product-block');
    if (!title || title.getAttribute('data-hb-moved') === 'done') return;
    title.setAttribute('data-hb-moved', 'done');

    var holder = document.createElement('div');
    holder.className = 'hb-pdp-title';
    holder.appendChild(title);

    var ref = head.querySelector('.product-reference');
    if (ref) holder.appendChild(ref);

    photos.parentNode.insertBefore(holder, photos.nextSibling);
  }

  /* ---------- 5. Guetesiegel in den Footer ---------- */
  /*
    Die Leiste steht MITTIG IM schwarzen Footer, ohne eigenen Kasten.

    TRUSTPILOT ALS BILD (16.09.2026, fuenfte Runde): Vorher stand hier
    das offizielle Trustpilot-Widget. Es laedt in einem iframe, zeichnet
    sich erst beim Sichtbarwerden und blieb zweimal nacheinander schlicht
    leer. Fuer eine Zeile, die auf jeder Seite ganz unten steht, ist das
    zu unsicher. Jetzt liegt dort das Logo als Bild
    (assets/trustpilot-weiss.png), verlinkt auf das HORANDO-Profil.
    Was dabei wegfaellt, ist die tagesaktuelle Note - die steht im
    Trusted-Shops-Siegel daneben.

    Trusted Shops kennt keine dunkle Variante, dessen Farben dreht die
    CSS-Datei auf Weiss.
  */

  function footerTrust() {
    if (!isMobile()) return;

    var footer = document.querySelector('.site-footer');
    if (!footer) return;
    if (footer.querySelector('.hb-footer-trust')) return;

    var row = document.createElement('div');
    row.className = 'hb-footer-trust';

    /* Trustpilot */
    var tp = document.createElement('div');
    tp.className = 'hb-footer-trust__item hb-footer-trust__item--tp';
    var tpLink = document.createElement('a');
    tpLink.href = TP_REVIEW_URL;
    tpLink.target = '_blank';
    tpLink.rel = 'noopener';
    tpLink.setAttribute('aria-label', 'HORANDO auf Trustpilot');

    var tpImg = document.createElement('img');
    tpImg.className = 'hb-footer-trust__logo';
    tpImg.src = assetUrl('trustpilot-weiss.png');
    tpImg.alt = 'Trustpilot';
    tpImg.width = 330;
    tpImg.height = 143;
    tpImg.loading = 'lazy';
    tpLink.appendChild(tpImg);
    tp.appendChild(tpLink);

    /* Trusted Shops */
    var ts = document.createElement('div');
    ts.className = 'hb-footer-trust__item hb-footer-trust__item--ts';
    var tsWidget = document.createElement('etrusted-widget');
    tsWidget.setAttribute('data-etrusted-widget-id', TS_WIDGET_ID);
    ts.appendChild(tsWidget);

    row.appendChild(tp);
    row.appendChild(ts);
    footer.appendChild(row);
  }

  /* ---------- 6. Platzhalter im Newsletter-Feld ---------- */
  /*
    Klaviyo liefert von Haus aus "Ihre E-Mail". Der vorhandene Text
    wird bewusst UEBERSCHRIEBEN. Sauberer waere der Eintrag im
    Klaviyo-Formulardesigner; dann faellt diese Funktion weg.
  */

  var PLACEHOLDERS = {
    de: 'E-Mail-Adresse eingeben',
    en: 'Enter your email address',
    fr: 'Saisissez votre adresse e-mail',
    es: 'Introduzca su correo electrónico',
    it: 'Inserisci il tuo indirizzo e-mail',
    pt: 'Introduza o seu e-mail',
    sv: 'Ange din e-postadress',
    hu: 'Adja meg e-mail-címét',
    ru: 'Введите адрес электронной почты',
    uk: 'Введіть адресу електронної пошти',
    zh: '请输入电子邮件地址'
  };

  function placeholderText() {
    var iso = (window.locale && window.locale.iso_code) ||
      document.documentElement.getAttribute('lang') || 'de';
    var lang = iso.toLowerCase().split('-')[0];
    return PLACEHOLDERS[lang] || PLACEHOLDERS.de;
  }

  function newsletterPlaceholder() {
    var wrap = document.querySelector('.Klaviyo_newsletter_wrap');
    if (!wrap) return false;

    var inputs = wrap.querySelectorAll('input[type="email"], input[type="text"]');
    if (!inputs.length) return false;

    var text = placeholderText();

    Array.prototype.forEach.call(inputs, function (input) {
      if (input.getAttribute('placeholder') !== text) {
        input.setAttribute('placeholder', text);
      }
    });

    return true;
  }

  /* ---------- 6b. Einwilligungs-Kaestchen ausrichten ---------- */
  /*
    Warum als Inline-Stil und nicht in der CSS-Datei?

    Klaviyos Zuruecksetz-Stylesheet nagelt Breite, Rand und
    Innenabstand des Textblocks mit !important UND hoeherer
    Spezifitaet fest. Gemessen: aus der CSS-Datei bleiben
    padding-left und margin-left auf 0 und die Breite auf 100% -
    auch mit !important. Dagegen kommt nur ein Stil direkt am
    Element an.

    Ausgangslage: Das Label ist eine Flex-Zeile aus Kaestchen-SVG,
    Haekchen-SVG und Textblock. Weil der Textblock 100% breit ist,
    bricht die Zeile um - Kaestchen oben, Text darunter - und das
    absolut gesetzte Haekchen findet keinen positionierten Vorfahren.
    Es lag deshalb neben dem Text statt im Kaestchen.

    Ergebnis hier: Label mit 32px Einzug und position: relative,
    beide SVGs absolut oben links uebereinander, Text daneben.

    Laeuft mehrfach (Klaviyo baut das Formular spaeter auf und kann
    es neu zeichnen) und tut beim zweiten Mal nichts mehr.
  */

  function important(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  function newsletterConsentLayout() {
    if (!isMobile()) return false;

    var labels = document.querySelectorAll(
      '.Klaviyo_newsletter_wrap .klaviyo-checkboxes label'
    );
    if (!labels.length) return false;

    Array.prototype.forEach.call(labels, function (label) {
      if (label.getAttribute('data-hb-consent') === 'done') return;

      var svgs = label.querySelectorAll('svg');
      var text = label.querySelector('div');
      if (!svgs.length || !text) return;

      label.setAttribute('data-hb-consent', 'done');

      important(label, 'display', 'block');
      important(label, 'position', 'relative');
      important(label, 'padding-left', '32px');
      important(label, 'margin-top', '4px');

      Array.prototype.forEach.call(svgs, function (svg) {
        important(svg, 'position', 'absolute');
        important(svg, 'left', '0');
        important(svg, 'top', '2px');
        important(svg, 'margin', '0');
        important(svg, 'width', '19px');
        important(svg, 'height', '19px');
      });

      important(text, 'display', 'block');
      important(text, 'width', 'auto');
      important(text, 'min-width', '0');
      important(text, 'margin', '0');
      important(text, 'line-height', '1.55');
    });

    return true;
  }

  /* ---------- 6c. Klaviyos Fehlermeldungen auf Deutsch ---------- */
  /*
    Haken setzen und wieder wegnehmen loest Klaviyos Pflichtfeldpruefung
    aus. Die Meldung kommt aus dem Formular und ist dort englisch
    hinterlegt ("This field is required") - auf einer deutschen Seite
    ein Fremdkoerper.

    Richtig geaendert wird das im Klaviyo-Formulardesigner; solange das
    nicht passiert ist, wird der Text hier ersetzt. Bewusst ueber einen
    Vergleich der ganzen Zeile und nicht ueber die Klassennamen: die
    erzeugt Klaviyo zufaellig und wechselt sie bei jeder
    Veroeffentlichung.

    Die Sprache kommt aus dem Dokument. In den anderen Maerkten bleibt
    der englische Text stehen, solange dort keine Uebersetzung
    hinterlegt ist - besser als ein deutscher Satz auf einer
    franzoesischen Seite.
  */

  var ERROR_TEXTS = {
    de: {
      'this field is required': 'Dieses Feld ist ein Pflichtfeld.',
      'please enter a valid email address': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      'please fill in all required fields': 'Bitte füllen Sie alle Pflichtfelder aus.'
    }
  };

  function newsletterErrorText() {
    if (!isMobile()) return;

    var iso = (window.locale && window.locale.iso_code) ||
      document.documentElement.getAttribute('lang') || 'de';
    var map = ERROR_TEXTS[iso.toLowerCase().split('-')[0]];
    if (!map) return;

    var wrap = document.querySelector('.Klaviyo_newsletter_wrap');
    if (!wrap) return;

    Array.prototype.forEach.call(wrap.querySelectorAll('div, span, p'), function (el) {
      if (el.children.length) return;
      var text = (el.textContent || '').trim();
      if (!text) return;
      var hit = map[text.toLowerCase().replace(/[.!]+$/, '')];
      if (hit && text !== hit) el.textContent = hit;
    });
  }

  /* Die Meldung erscheint erst beim Bedienen des Formulars - also
     danach noch einmal nachsehen. Der Zuhoerer haengt am Wrapper und
     ueberlebt damit, dass Klaviyo sein Formular neu zeichnet. */
  function watchNewsletterErrors() {
    if (window.__hbNewsletterWatched) return;

    var wrap = document.querySelector('.Klaviyo_newsletter_wrap');
    if (!wrap) return;

    window.__hbNewsletterWatched = true;

    ['click', 'change', 'input', 'blur'].forEach(function (name) {
      wrap.addEventListener(name, function () {
        setTimeout(newsletterErrorText, 60);
        setTimeout(newsletterErrorText, 400);
        setTimeout(newsletterConsentLayout, 60);
        setTimeout(newsletterTexts, 60);
      }, true);
    });
  }

  /* ---------- 6e. Texte des Newsletter-Formulars ---------- */
  /*
    HORANDO 06.10.2026 - Klaviyo liefert das Formular nur auf Deutsch
    aus, mit "GMBH" statt "GmbH" und einer englischen Feldgruppen-
    Beschriftung fuer Screenreader. Auf /en, /fr usw. stand deshalb
    ein deutscher Einwilligungstext unter einem fremdsprachigen Shop.

    Ersetzt werden Einwilligungstext, Knopf und die (unsichtbare)
    Beschriftung - nur, wenn dort noch der bekannte Ausgangstext steht.
    Geaendert wird der vorhandene Textknoten selbst (nodeValue), nicht
    textContent: so bleibt der Knoten erhalten, den Klaviyo beim
    Neuzeichnen wiederverwendet. Gilt fuer Handy UND Desktop.

    Sauberer waere die Pflege im Klaviyo-Formulardesigner; solange
    das Formular dort nur eine Sprache kennt, uebernimmt das hier.
  */

  var NL_TEXTS = {
    de: {
      consent: 'Ich bin damit einverstanden, dass die HORANDO Deutschland GmbH mir einen Newsletter zusendet. Mir ist bekannt, dass ich meine Einwilligung jederzeit widerrufen kann.',
      button: 'ABONNIEREN',
      legend: 'Einwilligung'
    },
    en: {
      consent: 'I agree that HORANDO Deutschland GmbH may send me a newsletter. I understand that I can withdraw my consent at any time.',
      button: 'SUBSCRIBE',
      legend: 'Consent'
    },
    fr: {
      consent: 'J’accepte que HORANDO Deutschland GmbH m’envoie une newsletter. Je sais que je peux retirer mon consentement à tout moment.',
      button: 'S’ABONNER',
      legend: 'Consentement'
    },
    es: {
      consent: 'Acepto que HORANDO Deutschland GmbH me envíe una newsletter. Sé que puedo revocar mi consentimiento en cualquier momento.',
      button: 'SUSCRIBIRSE',
      legend: 'Consentimiento'
    },
    it: {
      consent: 'Acconsento a ricevere la newsletter di HORANDO Deutschland GmbH. So di poter revocare il mio consenso in qualsiasi momento.',
      button: 'ISCRIVITI',
      legend: 'Consenso'
    },
    pt: {
      consent: 'Concordo que a HORANDO Deutschland GmbH me envie uma newsletter. Tenho conhecimento de que posso revogar o meu consentimento a qualquer momento.',
      button: 'SUBSCREVER',
      legend: 'Consentimento'
    },
    sv: {
      consent: 'Jag godkänner att HORANDO Deutschland GmbH skickar mig ett nyhetsbrev. Jag är medveten om att jag när som helst kan återkalla mitt samtycke.',
      button: 'PRENUMERERA',
      legend: 'Samtycke'
    },
    hu: {
      consent: 'Hozzájárulok, hogy a HORANDO Deutschland GmbH hírlevelet küldjön nekem. Tudomásul veszem, hogy hozzájárulásomat bármikor visszavonhatom.',
      button: 'FELIRATKOZÁS',
      legend: 'Hozzájárulás'
    },
    ru: {
      consent: 'Я соглашаюсь получать рассылку от HORANDO Deutschland GmbH. Мне известно, что я могу в любое время отозвать своё согласие.',
      button: 'ПОДПИСАТЬСЯ',
      legend: 'Согласие'
    },
    uk: {
      consent: 'Я погоджуюся отримувати розсилку від HORANDO Deutschland GmbH. Мені відомо, що я можу будь-коли відкликати свою згоду.',
      button: 'ПІДПИСАТИСЯ',
      legend: 'Згода'
    },
    zh: {
      consent: '我同意 HORANDO Deutschland GmbH 向我发送新闻通讯。我知道我可以随时撤回我的同意。',
      button: '订阅',
      legend: '同意'
    }
  };

  /* Ausgangstexte aus Klaviyo - nur diese werden ersetzt. */
  var NL_SOURCE = {
    consent: 'HORANDO Deutschland GMBH',
    button: 'ABONNIEREN',
    legend: 'How would you like to hear from us?'
  };

  function setText(el, match, text) {
    if (!el || !text) return;
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType !== 3) continue;
      var now = (n.nodeValue || '').trim();
      if (!now) continue;
      if (now === text) return;
      if (now.indexOf(match) > -1) n.nodeValue = text;
      return;
    }
  }

  function newsletterTexts() {
    var wrap = document.querySelector('.Klaviyo_newsletter_wrap');
    if (!wrap) return;

    var iso = (window.locale && window.locale.iso_code) ||
      document.documentElement.getAttribute('lang') || 'de';
    var t = NL_TEXTS[iso.toLowerCase().split('-')[0]] || NL_TEXTS.de;

    Array.prototype.forEach.call(
      wrap.querySelectorAll('.klaviyo-checkboxes label > div'),
      function (el) { setText(el, NL_SOURCE.consent, t.consent); }
    );
    Array.prototype.forEach.call(
      wrap.querySelectorAll('.klaviyo-form button'),
      function (el) { setText(el, NL_SOURCE.button, t.button); }
    );
    Array.prototype.forEach.call(
      wrap.querySelectorAll('.klaviyo-form legend'),
      function (el) { setText(el, NL_SOURCE.legend, t.legend); }
    );
  }

  /* ---------- 6d. Platzhalter der Suchzeile ---------- */
  /*
    "Suche" sagt nur, dass es ein Suchfeld ist. Bei Uhren ist die
    Referenznummer der haeufigste Sucheinstieg, und dass man danach
    suchen kann, stand nirgends.
  */

  var SEARCH_PLACEHOLDERS = {
    de: 'Marke, Modell oder Referenz',
    en: 'Brand, model or reference',
    fr: 'Marque, modèle ou référence',
    es: 'Marca, modelo o referencia',
    it: 'Marca, modello o referenza',
    pt: 'Marca, modelo ou referência',
    sv: 'Märke, modell eller referens',
    hu: 'Márka, modell vagy referencia',
    ru: 'Бренд, модель или референс',
    uk: 'Бренд, модель або референс',
    zh: '品牌、型号或编号'
  };

  function searchPlaceholder() {
    if (!isMobile()) return;

    var iso = (window.locale && window.locale.iso_code) ||
      document.documentElement.getAttribute('lang') || 'de';
    var text = SEARCH_PLACEHOLDERS[iso.toLowerCase().split('-')[0]];
    if (!text) return;

    var inputs = document.querySelectorAll(
      '.quick-search-overlay--search-bar .search__input'
    );

    Array.prototype.forEach.call(inputs, function (input) {
      if (input.getAttribute('placeholder') !== text) {
        input.setAttribute('placeholder', text);
      }
    });
  }

  /* ---------- 7. Suchoverlay an die Tastatur anpassen ---------- */
  /*
    Das Overlay haengt fixiert unter der Suchzeile. Seine Hoehe kam aus
    70vh bzw. 100vh - beides rechnet mit dem LAYOUT-Viewport, den die
    iOS-Tastatur nicht verkleinert. Sobald die Tastatur aufging, reichte
    der Kasten weit dahinter: die Vorschlaege lagen halb darunter und
    statt im Overlay scrollte die Seite.

    window.visualViewport kennt die tatsaechlich sichtbare Flaeche.
    Daraus wird --hb-search-max berechnet; den Rest macht die CSS-Datei.
  */

  function sizeSearchOverlay() {
    if (!isMobile()) return;

    var modal = document.querySelector(
      '.quick-search-overlay--search-bar .quick-search-overlay__modal'
    );
    if (!modal) return;

    var vv = window.visualViewport;
    var visibleBottom = vv ? vv.height + vv.offsetTop : window.innerHeight;
    var pos = modal.getBoundingClientRect().top;
    var avail = Math.round(visibleBottom - pos - 12);

    if (!isFinite(avail) || avail < 220) avail = 220;

    document.documentElement.style.setProperty('--hb-search-max', avail + 'px');
  }

  function watchSearchOverlay() {
    if (window.__hbSearchWatched) return;
    window.__hbSearchWatched = true;

    var vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', sizeSearchOverlay);
      vv.addEventListener('scroll', sizeSearchOverlay);
    }
    window.addEventListener('resize', sizeSearchOverlay);
    window.addEventListener('orientationchange', function () {
      setTimeout(sizeSearchOverlay, 300);
    });

    /* Beim Antippen des Suchfeldes faehrt die Tastatur erst danach
       hoch - deshalb zweimal nachmessen. */
    document.addEventListener('focusin', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.quick-search-overlay')) return;
      sizeSearchOverlay();
      setTimeout(sizeSearchOverlay, 350);
      setTimeout(sizeSearchOverlay, 900);
    });
  }

  /* ---------- 8. Lupe und Vollbildansicht auf der Produktseite -------- */
  /*
    Warum eigenhaendig und nicht der Zoom des Themes?

    Das Theme bringt PhotoSwipe mit, die Bilder tragen sogar schon
    data-photoswipe-src. Ausgeloest wird es aber nur, wenn die Section
    <product-images data-zoom="true"> ausgibt - und dieser Schalter ist
    eine Section-Einstellung, die fuer Handy UND Desktop gleichzeitig
    gilt. Der Desktop soll unangetastet bleiben, also baut das Skript
    seine eigene Vollbildansicht. Sie ist klein, haengt an nichts
    Fremdem und kann jederzeit wieder raus.

    Bedienung:
      - Tippen auf das Bild oder auf die Lupe oeffnet das Vollbild.
      - Zwei Finger zum Vergroessern (bis vierfach), ein Finger zum
        Verschieben.
      - Doppeltippen wechselt zwischen normal und 2,5-fach.
      - Nach unten wischen oder das Kreuz schliesst.
      - Bei mehreren Bildern wischen oder die Pfeile in der Leiste
        unter dem Bild (dort steht auch der Zaehler).
  */

  var MAX_SCALE = 4;
  var TAP_SCALE = 2.5;

  var ICON_ZOOM =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/>' +
    '<path d="M11 8.5v5M8.5 11h5"/></svg>';

  var ICON_CLOSE =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  var ICON_PREV =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="m15 5-7 7 7 7"/></svg>';

  var ICON_NEXT =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="m9 5 7 7-7 7"/></svg>';

  var lb = null; // gemerkte Vollbildansicht, wird einmal gebaut

  /* Die groesste verfuegbare Fassung eines Bildes. PhotoSwipe-Quelle
     zuerst, sonst die aktuelle Quelle mit hoeherem width-Parameter. */
  function bigSrc(img) {
    var src = img.getAttribute('data-photoswipe-src');
    if (!src) src = img.currentSrc || img.src || '';
    if (!src) return '';
    if (src.indexOf('width=') > -1) {
      src = src.replace(/([?&])width=\d+/, '$1width=1800');
    }
    return src;
  }

  function galleryImages() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '.product__main-photos .product-main-slide .image-wrap img'
    ));
  }

  function buildLightbox() {
    if (lb) return lb;

    var root = document.createElement('div');
    root.className = 'hb-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('data-open', 'false');

    root.innerHTML =
      '<div class="hb-lightbox__stage"><img class="hb-lightbox__img" alt=""></div>' +
      '<button type="button" class="hb-lightbox__close" aria-label="Schliessen">' + ICON_CLOSE + '</button>' +
      /* 28.09.2026: Pfeile und Zaehler in einer Leiste UNTER dem Bild,
         nicht mehr im Bild. Der Hinweistext ist entfallen. */
      '<div class="hb-lightbox__bar">' +
        '<button type="button" class="hb-lightbox__nav hb-lightbox__nav--prev" aria-label="Vorheriges Bild">' + ICON_PREV + '</button>' +
        '<div class="hb-lightbox__count"></div>' +
        '<button type="button" class="hb-lightbox__nav hb-lightbox__nav--next" aria-label="Naechstes Bild">' + ICON_NEXT + '</button>' +
      '</div>';

    document.body.appendChild(root);

    lb = {
      root: root,
      stage: root.querySelector('.hb-lightbox__stage'),
      img: root.querySelector('.hb-lightbox__img'),
      count: root.querySelector('.hb-lightbox__count'),
      prev: root.querySelector('.hb-lightbox__nav--prev'),
      next: root.querySelector('.hb-lightbox__nav--next'),
      list: [],
      index: 0,
      scale: 1,
      tx: 0,
      ty: 0
    };

    function apply() {
      lb.img.style.transform =
        'translate(' + lb.tx + 'px,' + lb.ty + 'px) scale(' + lb.scale + ')';
    }

    function reset() {
      lb.scale = 1;
      lb.tx = 0;
      lb.ty = 0;
      apply();
    }

    lb.apply = apply;
    lb.reset = reset;

    lb.show = function (i) {
      if (!lb.list.length) return;
      lb.index = (i + lb.list.length) % lb.list.length;
      lb.img.src = lb.list[lb.index];
      reset();
      var many = lb.list.length > 1;
      root.classList.toggle('hb-lightbox--single', !many);
      lb.count.textContent = many ? (lb.index + 1) + ' / ' + lb.list.length : '';
    };

    lb.close = function () {
      root.setAttribute('data-open', 'false');
      document.body.classList.remove('hb-lightbox-open');
      lb.img.removeAttribute('src');
    };

    root.querySelector('.hb-lightbox__close').addEventListener('click', lb.close);
    lb.prev.addEventListener('click', function () { lb.show(lb.index - 1); });
    lb.next.addEventListener('click', function () { lb.show(lb.index + 1); });

    document.addEventListener('keydown', function (e) {
      if (root.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') lb.close();
      if (e.key === 'ArrowLeft') lb.show(lb.index - 1);
      if (e.key === 'ArrowRight') lb.show(lb.index + 1);
    });

    /* ---- Finger ---- */

    var startDist = 0, startScale = 1;
    var startX = 0, startY = 0, startTx = 0, startTy = 0;
    var lastTap = 0, moved = false;

    function dist(t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    lb.stage.addEventListener('touchstart', function (e) {
      moved = false;
      if (e.touches.length === 2) {
        startDist = dist(e.touches);
        startScale = lb.scale;
      } else if (e.touches.length === 1) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = lb.tx;
        startTy = lb.ty;
      }
    }, { passive: true });

    lb.stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && startDist) {
        e.preventDefault();
        moved = true;
        var s = startScale * (dist(e.touches) / startDist);
        lb.scale = Math.max(1, Math.min(MAX_SCALE, s));
        apply();
      } else if (e.touches.length === 1) {
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
        if (lb.scale > 1) {
          e.preventDefault();
          lb.tx = startTx + dx;
          lb.ty = startTy + dy;
          apply();
        }
      }
    }, { passive: false });

    lb.stage.addEventListener('touchend', function (e) {
      if (lb.scale <= 1) {
        /* Nach unten wischen schliesst. */
        if (moved && e.changedTouches.length === 1) {
          var dy = e.changedTouches[0].clientY - startY;
          var dx = e.changedTouches[0].clientX - startX;
          if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { lb.close(); return; }
          if (lb.list.length > 1 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
            lb.show(lb.index + (dx < 0 ? 1 : -1));
            return;
          }
        }
        reset();
      }

      if (!moved) {
        var now = Date.now();
        if (now - lastTap < 300) {
          lb.scale = lb.scale > 1 ? 1 : TAP_SCALE;
          lb.tx = 0;
          lb.ty = 0;
          apply();
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }
    }, { passive: true });

    return lb;
  }

  function openLightbox(index) {
    var imgs = galleryImages();
    if (!imgs.length) return;

    var box = buildLightbox();
    box.list = imgs.map(bigSrc).filter(Boolean);
    box.root.setAttribute('data-open', 'true');
    document.body.classList.add('hb-lightbox-open');
    box.show(index || 0);
  }

  function productZoom() {
    if (!/(^|\s)template-product/.test(document.body.className)) return;
    if (!isMobile()) return;

    var photos = document.querySelector('.product__photos');
    if (!photos) return;

    var imgs = galleryImages();
    if (!imgs.length) return;

    /* Tippen auf das Bild. Flickity tauscht die Folien aus, deshalb
       haengt der Zuhoerer am Container und nicht an jedem Bild. */
    if (photos.getAttribute('data-hb-zoom') !== 'done') {
      photos.setAttribute('data-hb-zoom', 'done');

      photos.addEventListener('click', function (e) {
        var img = e.target && e.target.closest
          ? e.target.closest('.product-main-slide .image-wrap img')
          : null;
        if (!img) return;
        e.preventDefault();
        var all = galleryImages();
        openLightbox(all.indexOf(img));
      });
    }

    /* Lupe - damit man die Vollbildansicht auch sieht. */
    if (!photos.querySelector('.hb-zoom-btn')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hb-zoom-btn';
      btn.setAttribute('aria-label', 'Bild vergroessern');
      btn.innerHTML = ICON_ZOOM;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        /* Die gerade sichtbare Folie zuerst zeigen. */
        var current = photos.querySelector(
          '.product-main-slide.is-selected .image-wrap img'
        );
        var all = galleryImages();
        openLightbox(current ? all.indexOf(current) : 0);
      });
      photos.appendChild(btn);
    }
  }

  /* ---------- 12. Kaufleiste auf der Produktseite ---------- */
  /*
    Die Leiste des Themes zeigt Bild, Titel und einen vollbreiten Knopf
    untereinander - und keinen Preis. Hier kommt der Preis hinein, das
    Stylesheet blendet Bild und Titel aus.

    Der Knopftext wird gekuerzt, sonst bleibt neben ihm kein Platz fuer
    den Preis. Gekuerzt wird nur, solange dort der normale Kauftext
    steht - "Ausverkauft" bleibt unangetastet. Welcher Text der normale
    ist, merkt sich das Skript beim ersten Durchlauf selbst; so stimmt
    es in allen Sprachen, ohne dass der lange Text hier stehen muss.
  */

  var ATC_SHORT = {
    de: 'In den Warenkorb',
    en: 'Add to cart',
    fr: 'Ajouter au panier',
    es: 'Añadir al carrito',
    it: 'Aggiungi al carrello',
    pt: 'Adicionar ao carrinho',
    sv: 'Lägg i varukorgen',
    hu: 'Kosárba',
    ru: 'В корзину',
    uk: 'До кошика',
    zh: '加入购物车'
  };

  function atcPriceText() {
    var el =
      document.querySelector('.block-price__container .main_price_span') ||
      document.querySelector('.block-price__regular .trans-money');
    if (!el) return '';
    return el.textContent.replace(/\s+/g, ' ').trim();
  }

  function stickyAtcBar() {
    if (!isMobile()) return;

    var bar = document.querySelector('.sticky-atc');
    if (!bar) return;

    var inner = bar.querySelector('.sticky-atc__inner');
    if (!inner) return;

    var price = inner.querySelector('.hb-atc-price');
    if (!price) {
      price = document.createElement('span');
      price.className = 'hb-atc-price';
      inner.insertBefore(price, inner.firstChild);
    }

    var text = atcPriceText();
    if (text && price.textContent !== text) price.textContent = text;

    /* Waehrungsumschalter und Variantenwechsel schreiben den Preis
       nachtraeglich um - einmal beobachten reicht. */
    if (!stickyAtcBar.watching && window.MutationObserver) {
      var source = document.querySelector('.block-price__container');
      if (source) {
        stickyAtcBar.watching = true;
        new MutationObserver(function () {
          var now = atcPriceText();
          if (now && price.textContent !== now) price.textContent = now;
        }).observe(source, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    var btn = inner.querySelector('.sticky-atc__btn');
    if (!btn || btn.getAttribute('data-hb-atc')) return;

    var iso =
      (window.locale && window.locale.iso_code) ||
      document.documentElement.getAttribute('lang') ||
      'de';
    var short = ATC_SHORT[iso.toLowerCase().split('-')[0]];
    if (!short) return;

    var long = btn.textContent.replace(/\s+/g, ' ').trim();
    if (!long || long === short) return;

    btn.setAttribute('data-hb-atc', long);

    function shorten() {
      var now = btn.textContent.replace(/\s+/g, ' ').trim();
      if (now === long) btn.textContent = short;
    }

    shorten();

    /* Das Theme schreibt den Knopftext bei jedem Variantenwechsel neu. */
    if (window.MutationObserver) {
      new MutationObserver(shorten).observe(btn, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  /*
    Ob die Leiste erscheint, entscheidet das Theme mit einem
    IntersectionObserver auf dem eigentlichen Kaufknopf. Der ist an den
    Zeichentakt des Browsers gekoppelt: laeuft der Tab im Hintergrund
    oder bremst das Geraet, meldet er sich verspaetet oder gar nicht -
    und die Leiste bleibt unten stehen.

    Hier dieselbe Entscheidung ohne Beobachter: die Position des
    Kaufknopfs wird bei jedem Scrollen gemessen. Gezeigt wird, sobald
    er nach oben aus dem Bild ist und der Fuss der Seite noch mehr als
    eine Bildschirmhoehe entfernt ist. Beide Wege setzen ihre eigene
    Klasse, sie koennen sich also nicht gegenseitig ausknipsen.
  */

  function stickyAtcScroll() {
    if (stickyAtcScroll.bound || !isMobile()) return;
    if (!document.querySelector('.sticky-atc')) return;

    stickyAtcScroll.bound = true;

    function update() {
      /* Bewusst bei jedem Durchlauf neu gesucht: Apps und der
         Waehrungsumschalter zeichnen den Produktabschnitt gelegentlich
         neu. Wer sich die Elemente einmal merkt, haelt danach auf
         Knoepfe fest, die nicht mehr in der Seite haengen - genau das
         passiert dem Skript des Themes. */
      var bar = document.querySelector('.sticky-atc');
      var original = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!bar || !original) return;

      var box = original.getBoundingClientRect();
      var docHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      var fromBottom = docHeight - (window.pageYOffset + window.innerHeight);
      var show = box.bottom < 0 && fromBottom > window.innerHeight;

      if (bar.classList.contains('hb-atc-on') === show) return;

      bar.classList.toggle('hb-atc-on', show);
      if (show) {
        bar.setAttribute('aria-hidden', 'false');
      } else if (!bar.classList.contains('is-visible')) {
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /*
    Oeffnungszeiten im Footer ueber die volle Zeile.

    Der Text kommt aus den Uebersetzungen und traegt zwei feste
    Umbrueche, die aus der schmalen Desktop-Spalte stammen:
    "Wir stehen Ihnen telefonisch<br>Mo. - Fr. von 10:00 - 18:00
    Uhr<br>zur Verfuegung". Mobil ist der Block 343px breit, die
    Zeilen brachen also mitten im Satz um und liessen rechts Platz
    frei.

    Die <br> sind die einzigen Trenner - dazwischen steht kein
    Leerzeichen. Sie nur auszublenden klebt die Woerter zusammen
    ("telefonischMo."). Deshalb wird jedes <br> durch ein echtes
    Leerzeichen ersetzt; danach bricht der Satz dort um, wo die
    Zeile zu Ende ist.

    Der Text selbst bleibt unveraendert und gilt weiter in allen
    zehn Sprachen. Auf dem Desktop passiert nichts.
  */

  function footerOpeningHours() {
    if (!isMobile()) return;

    var hours = document.querySelector(
      '.footer__block--contact .footer__hours'
    );
    if (!hours) return;

    var breaks = hours.querySelectorAll('br');
    for (var i = 0; i < breaks.length; i++) {
      var br = breaks[i];
      if (br.parentNode) {
        br.parentNode.replaceChild(document.createTextNode(' '), br);
      }
    }
  }

  /* ---------- Anlauf ---------- */

  function run() {
    try {
      collapseTexts();
      collapseFooter();
      trimFeatureHeadings();
      productTitleUnderPhoto();
      productZoom();
      stickyAtcBar();
      stickyAtcScroll();
      footerTrust();
      footerOpeningHours();
      newsletterPlaceholder();
      newsletterConsentLayout();
      newsletterErrorText();
      newsletterTexts();
      watchNewsletterErrors();
      searchPlaceholder();
      watchSearchOverlay();
      sizeSearchOverlay();
    } catch (e) {
      // Eine kaputte Verschoenerung darf die Seite nicht mitreissen.
      if (window.console && console.warn) console.warn('[horando-braun-mobil]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  setTimeout(run, 1500);

  /* Klaviyo haengt sein Formular teils erst nach mehreren Sekunden ein
     und setzt den eigenen Platzhalter danach noch einmal. */
  (function waitForKlaviyo() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      try {
        newsletterPlaceholder();
        newsletterConsentLayout();
        newsletterErrorText();
        newsletterTexts();
      } catch (e) {
        clearInterval(timer);
        return;
      }
      if (tries > 40) clearInterval(timer);
    }, 500);
  })();

  if (window.MutationObserver) {
    var seen = false;
    var obs = new MutationObserver(function () {
      if (seen) return;
      if (document.querySelector('.footer__block--menu .footer__menu')) {
        seen = true;
        run();
        obs.disconnect();
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    });
  }
})();
